<template>
  <div>
    <div class="text-action-default-low body-1 mb-16">
      {{ i18n(translations.legalDocumentsDescription) }}
    </div>
    <div
      v-for="documentType in documentTypes"
      :key="documentType.code"
      class="mb-20"
    >
      <div class="flex items-start">
        <IconArrowRight />
        <div class="ml-12">
          <div class="body-1">
            {{ documentType.label }}
          </div>
          <div
            v-if="getDocumentDescription(i18n, documentType.code)"
            class="caption mt-8"
          >
            {{ getDocumentDescription(i18n, documentType.code) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GetLegalDocumentsMetadata } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconArrowRight } from '@ds/icons/IconArrowRight'

import { getDocumentDescription } from '../../LegalDocuments.utils'

import translations from './LegalDocumentsEmptyState.translations'

defineProps<{
  documentTypes: GetLegalDocumentsMetadata['legalDocumentTypes']
}>()

const i18n = useI18n()
</script>
